import React from 'react';
import { Route } from 'react-router-dom';

export const generateRoutes = (routesArr) => routesArr.map(({
  key, title, link, component, exact,
}) => <Route key={`${key}@${title}`} path={link} exact={exact}>{component}</Route>);
